/* Vault grid hover video.

   Loads nothing until the pointer settles on a tile. The delay matters: without
   it, sweeping a mouse diagonally across a three-across grid fires a download on
   every tile it crosses. At roughly 8 MB a clip that is most of the page weight
   budget spent on videos nobody looked at.

   Handlers are delegated from the grid container rather than bound per tile, so
   this survives the theme's AJAX filtering and pagination redrawing the grid. */
(function () {
  var INTENT_MS = 120;

  // No hover on touch, and reduced motion means no autoplaying clips at all.
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!canHover || calm) return;

  var timers = new WeakMap();

  function attach(wrap) {
    var v = wrap.querySelector('video');
    if (!v) return null;

    /* Set here rather than trusting the markup.

       These three are load bearing and were the cause of a real bug: the clips
       played once and stopped, holding their final frame. Because the pieces are
       shot on white silk that last frame is white, so a tile that had been
       hovered went blank white and stayed that way until the pointer left.

       loop is the fix. muted and playsInline are set defensively because a
       browser will refuse to autoplay without them, and the refusal is silent:
       play() rejects, the catch below swallows it, and the tile just never
       animates with nothing in the console to explain why.

       Assigning the properties rather than the attributes means this holds even
       if the markup in product-grid-item.liquid changes, which matters because
       that snippet renders every grid on the site and is edited by other work. */
    v.loop = true;
    v.muted = true;
    v.playsInline = true;

    if (!v.dataset.loaded) {
      v.dataset.loaded = '1';
      var src = v.getAttribute('data-src');
      if (src) {
        var s = document.createElement('source');
        s.src = src;
        s.type = 'video/mp4';
        v.appendChild(s);
        v.load();
      }
      // loadeddata rather than canplay: we only need one decoded frame before
      // fading in, not enough buffer to play through.
      v.addEventListener('loadeddata', function () { wrap.classList.add('is-ready'); });

      /* Belt and braces. If loop is ever defeated (a stream the browser will not
         seek, a codec that reports ended early), rewind and resume rather than
         leaving the last frame parked over the product photo. */
      v.addEventListener('ended', function () {
        if (!v.loop) return;
        try { v.currentTime = 0; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        catch (err) { /* ignore */ }
      });
    } else {
      wrap.classList.add('is-ready');
    }
    return v;
  }

  function enter(tile) {
    var wrap = tile.querySelector('.grid-product__video');
    if (!wrap) return;
    if (timers.has(tile)) clearTimeout(timers.get(tile));
    timers.set(tile, setTimeout(function () {
      var v = attach(wrap);
      if (!v) return;
      var p = v.play();
      if (p && p.catch) p.catch(function () { /* autoplay refused, image stays */ });
    }, INTENT_MS));
  }

  function leave(tile) {
    if (timers.has(tile)) { clearTimeout(timers.get(tile)); timers.delete(tile); }
    var wrap = tile.querySelector('.grid-product__video');
    if (!wrap) return;
    var v = wrap.querySelector('video');
    if (v) { v.pause(); v.currentTime = 0; }
  }

  document.addEventListener('mouseover', function (e) {
    var tile = e.target.closest ? e.target.closest('.grid-product') : null;
    if (!tile || !tile.querySelector('.grid-product__video')) return;
    if (tile.contains(e.relatedTarget)) return;
    enter(tile);
  });

  document.addEventListener('mouseout', function (e) {
    var tile = e.target.closest ? e.target.closest('.grid-product') : null;
    if (!tile) return;
    if (tile.contains(e.relatedTarget)) return;
    leave(tile);
  });
})();
